var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-y":"auto","height":"100%"}},[_c('VueQueryBuilder',{ref:"queryBuilder",attrs:{"customItems":_vm.customItems,"slots":_vm.slots,"labels":_vm.labels,"maxDepth":3,"rules":_vm.rules},on:{"change":_vm.handleChange},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }